import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthenticationService } from '../authentication.Service';
import { fadeInAnimation, fadeInOnEnterAnimation, fadeOutOnLeaveAnimation } from 'angular-animations';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  animations: [
    fadeInOnEnterAnimation({ duration: 1000 }),
    fadeOutOnLeaveAnimation({ duration: 500 }),
    fadeInAnimation({ anchor: 'enter', duration: 1000 }),
    fadeInAnimation({ anchor: 'errorFadein', duration: 1000, delay: 100 })
  ],
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  formGroup: FormGroup;

  errorMsg: string;
  displayError: boolean;
  displaySuccess: boolean;

  constructor(private authService: AuthenticationService) {
    this.errorMsg = "";
    this.displayError = false;
    this.displaySuccess = false;
    this.formGroup = new FormGroup({
      username: new FormControl("", [Validators.required])
    });
  }

  ngOnInit(): void {
  }

  onSubmit() {
    if (this.formGroup.valid) {
      this.authService.requestResetPassword(this.formGroup.value.username)
        .subscribe(result => {
            this.displayError = false;
            this.displaySuccess = true;
          },
          error => {
            console.error(error);
            this.errorMsg = "There was a problem producing your reset email";
            this.displayError = true;
          });
    }
  }

}
